export default {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      snap: true,
      crossStyle: {
        color: '#999'
      }
    }
  },
  legend: {},
  xAxis: [
    {
      type: 'category',
      axisPointer: {
        type: 'shadow'
      }
    },
    {
      type: 'category',
      offset: -435,
      axisPointer: {
        type: 'shadow'
      }
    }
  ],
  yAxis: [],
  series: []
}